


export const Label = (
  {children, semantic="default", emphasis="heavy", size="lg", shape="square", withIcon=false}
) => {

  return (
    <span className={`label-component ${semantic} ${emphasis} ${size} ${shape} ${withIcon ? "with-icon" : ""}`}>
      {children}
    </span>
  );

};